import { FC, useEffect } from 'react';
import { matchPath, useNavigate, useRouteError } from 'react-router-dom';

import { DEV, LOCK_PAGE_PATH, LOGIN_PAGE_PATH, STREAMS_STREAM_CATEGORY_BY_ID_PATH } from 'application/consts';
import { StreamsCategoryParamValues } from 'application/pages/StreamPage';

import { useLocation } from './useLocation';
import RouterUtils from './utils';

const streamsRecommendedPage = RouterUtils.generatePath(STREAMS_STREAM_CATEGORY_BY_ID_PATH, {
  category: StreamsCategoryParamValues.RECOMMENDED,
});

const ERROR_MESSAGE_HAS_NOT_COMPANY = "Cannot read properties of null (reading 'id')";

const RouterErrorBoundary: FC = () => {
  const error = useRouteError() as Error;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isDouble = location.pathname.includes('//');
    const isStreams = matchPath({ path: '/streams', end: true }, location.pathname);
    const isDevMatch = location.pathname.includes('dev');

    const isDebugMatch = matchPath({ path: '/debug', end: true }, location.pathname);
    const isTestMatch = matchPath({ path: '/test', end: true }, location.pathname);

    if (isDouble || isDevMatch || isDebugMatch || isTestMatch) {
      navigate(LOGIN_PAGE_PATH, { replace: true });
    } else if (isStreams) {
      navigate(streamsRecommendedPage, { replace: true });
    }
  }, [location.pathname]);

  useEffect(() => {
    if (error.message === ERROR_MESSAGE_HAS_NOT_COMPANY) {
      navigate(LOCK_PAGE_PATH, { replace: true });
    }
  }, [error]);

  if (DEV) {
    console.error(error);
  }

  if (error?.message) {
    return <div>{`${error.message}`}</div>;
  }

  return <div>{`${error}`}</div>;
};

export default RouterErrorBoundary;
